import React from "react";
import VenmoPng from "../../svg/venmo_qr_code.png";
import "./TipJarPage.css";
import CardContainer from "../generic/CardContainer";
import InfoCard from "../generic/InfoCard";

interface Props {}

const DESKTOP_LINK = "https://account.venmo.com/pay?recipients=CurtisMakesThings&audience=private&note=hooray%20music!";
/** Venmo deeplinking is fubar, so play it safe on narrow viewports */
const MOBILE_LINK = "https://venmo.com/u/CurtisMakesThings";
const isMobile = window.screen.width < 600;

function TipJarPage(_props: Props) {
  const SITE_LINK = isMobile ? MOBILE_LINK : DESKTOP_LINK;
  return (
    <CardContainer>
      <InfoCard>
        <div className="tip-jar-inner-card centered-list-of-stuff">
          <h2>Tip Jar</h2>

          <p>Thank you! Every tip goes directly into my cat's stomach... figuratively, don't worry.</p>
          <p>
            I'm @CurtisMakesThings via the{" "}
            <a href={SITE_LINK} target="_blank" rel="noreferrer">
              Venmo website
            </a>
            , or you can scan the QR code below.
          </p>

          <div className="venmo-png-box">
            <span className="venmo-png-img-span">
              <img src={VenmoPng} alt="CurtisMakesThings is my venmo 'business' account."></img>
            </span>
          </div>
        </div>
      </InfoCard>
    </CardContainer>
  );
}

export default TipJarPage;
